import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from 'src/app/core/base.component';
import { StringHelpers } from 'src/app/shared/helpers/string-helpers';
import { GlobalDataService } from 'src/app/shared/services/global-data.service';
import { SessionService } from 'src/app/shared/services/session.service';
import { SponsorType } from '../sponsor-type.enum';
import { SPONSOR_TYPE_OPTIONS } from '../sponsor-type.helpers';
import { SponsorService } from '../sponsor.service';

@Component({
  selector: 'app-sponsor-create',
  templateUrl: './sponsor-create.component.html',
  styleUrls: ['./sponsor-create.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class SponsorCreateComponent extends BaseComponent implements OnInit, AfterViewInit, OnDestroy {
  public canCreateSponsor = false;
  public readonly sponsorTypeOptions = SPONSOR_TYPE_OPTIONS;
  private readonly destroyed$ = new Subject<void>();

  public form = new FormGroup({
    name: new FormControl('', { validators: Validators.required }),
    company: new FormControl(''),
    contactEmail: new FormControl('', {
      validators: [Validators.required, Validators.email]
    }),
    requestReceipt: new FormControl(false),
    amount: new FormControl<number | null>(null),
    type: new FormControl(SponsorType.Donation),
    notes: new FormControl(''),
    outingIterationId: new FormControl<string | null>(null),
    createdBy: new FormControl<string | null>(null)
  });

  constructor(
    public sessionService: SessionService,
    private sponsorService: SponsorService,
    private globalDataService: GlobalDataService,
    stringHelpers: StringHelpers,
    private router: Router,
    private cdRef: ChangeDetectorRef
  ) {
    super(sessionService, stringHelpers);
  }

  ngOnInit(): void {
    if (this.isGlobalOutingSet()) {
      this.selectedIteration = this.getGlobalOutingIteration();
      this.canCreateSponsor = true;
      this.cdRef.markForCheck();
    }
  }

  ngAfterViewInit(): void {
    this.globalDataService.iterationSelectionEvent.pipe(takeUntil(this.destroyed$)).subscribe((result) => {
      this.selectedIteration = result;
      this.canCreateSponsor = true;
      this.cdRef.markForCheck();
    });
  }

  ngOnDestroy(): void {
    this.destroyed$.next();
    this.destroyed$.complete();
  }

  onSubmit({ value, valid }: FormGroup): void {
    if (!valid) {
      return;
    }
    this.isLoading = true;
    this.cdRef.markForCheck();
    value.createdBy = this.sessionService.getUserId();
    value.outingIterationId = this.selectedIteration.id;
    this.sponsorService.create(value).subscribe({
      next: () => {
        this.isLoading = false;
        this.form.reset({
          type: SponsorType.Donation,
          requestReceipt: false
        });
        this.cdRef.markForCheck();
        this.router.navigate(['/outing-management/administration/sponsors']);
      },
      error: (err: any) => {
        this.isLoading = false;
        if (err.status === 400) {
          this.setError(err, this.form);
        }
        this.cdRef.markForCheck();
      }
    });
  }
}
